import { render, staticRenderFns } from "./EntrySidebar.vue?vue&type=template&id=a5bd882c&"
import script from "./EntrySidebar.vue?vue&type=script&lang=js&"
export * from "./EntrySidebar.vue?vue&type=script&lang=js&"
import style0 from "./EntrySidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports